const DEFAULT_FREE_BASIC_MAX_BOTS = 3;

const BOT_LIMIT_KEYS = [
  'maxBots',
  'max_bots',
  'maxBotsPerCompany',
  'max_bots_per_company',
  'botLimit',
  'bot_limit',
];

const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

const normalizePlanRole = (value) => {
  if (!value) return null;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return null;
  if (['gratis', 'free', 'free_tier', 'freetier'].includes(normalized)) return 'free';
  if (['payasyougo', 'pay_as_you_go', 'payg', 'usage', 'metered'].includes(normalized)) return 'payasyougo';
  return normalized;
};

const hasPlanToken = (plan, tokens) => {
  const values = [
    plan?.code,
    plan?.name,
    plan?.tier,
    plan?.planTier,
    plan?.metadata?.plan_code,
    plan?.metadata?.planCode,
    plan?.features?.plan_code,
    plan?.features?.planCode,
  ]
    .map((value) => String(value || '').trim().toLowerCase())
    .filter(Boolean);
  return values.some((value) => tokens.some((token) => value === token || value.includes(token)));
};

const isFreeOrBasicPlan = (plan) => {
  const role = normalizePlanRole(
    plan?.features?.planRole
    || plan?.metadata?.planRole
    || plan?.metadata?.plan_role
    || plan?.features?.plan_role,
  );
  if (role === 'free' || role === 'payasyougo') return true;
  return hasPlanToken(plan, ['free', 'gratis', 'basic']);
};

export const resolvePlanMaxBots = (plan) => {
  if (!plan) return null;
  const sources = [plan.features || {}, plan.metadata || {}];
  for (const source of sources) {
    for (const key of BOT_LIMIT_KEYS) {
      const numeric = toNumber(source[key]);
      if (Number.isFinite(numeric)) {
        return Math.max(0, Math.floor(numeric));
      }
    }
  }
  return isFreeOrBasicPlan(plan) ? DEFAULT_FREE_BASIC_MAX_BOTS : null;
};

export const formatBotLimitHighlight = (maxBots) => {
  const numeric = toNumber(maxBots);
  if (!Number.isFinite(numeric) || numeric <= 0) return null;
  return `Maks ${Math.floor(numeric)} boter`;
};

export const normalizePlanHighlightsForBotLimit = (plan, highlights = []) => {
  const botLimitLabel = formatBotLimitHighlight(resolvePlanMaxBots(plan));
  if (!botLimitLabel) return highlights;

  const normalized = highlights.map((highlight) => {
    const text = String(highlight || '').trim();
    const mentionsBots = /\b(bot|boter|botter|bots|chatbots?)\b/i.test(text);
    const saysUnlimited = /\b(ubegrenset|unlimited)\b/i.test(text);
    if (mentionsBots && saysUnlimited) {
      return botLimitLabel;
    }
    return highlight;
  });

  const seen = new Set();
  return normalized.filter((highlight) => {
    const key = String(highlight || '').trim().toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
